import useAccount from './useAccount'
import useRouter from './useRouter'

export const useTablePath = () => {
  const account = useAccount()
  const router = useRouter()

  const customer = account.customer?.name || ''
  const job = account.job?.name || ''
  const tableParam = router.params.table || ''
  const fullTable = tableParam ? tableParam.match(/\.cbt$/) ? tableParam : `${tableParam}.cbt` : ''
  let tableTitle = (fullTable.split('/').pop() || '').replace(/\.cbt$/, '')
  const parts = fullTable.split('/')
  const tableName = parts.pop()
  const folderPath = parts.join('/')
  const filter = router.params.filter || ''
  const multiTableId = router.params.multiTableId
  const isMultiTableRoute = router.name === 'multitables'

  if(tableTitle == 'new') {
    tableTitle = 'New Table'
  }

  return {
    customer,
    job,
    table: fullTable,
    tableTitle,
    tableParam,
    filter,
    multiTableId,
    isMultiTableRoute,
    tableName,
    folderPath,
  }
}

export default useTablePath
